export default __webpack_public_path__ + "static/media/risk-accept.59a2a60e.svg";